import React from "react";
import { Paper, Typography, Stack, Box } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";

export default function ComparisonCard() {
  return (
    <Paper
      sx={{
        p: { xs: 2.2, md: 2.6 },
        borderRadius: 1,
        
        height: { xs: 280, md: 360, lg: 260 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography fontWeight={950} mb={1}>
          Comparativo mensal
        </Typography>

        <Typography fontSize={28} fontWeight={950}>
          R$ 248.430
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center" mt={0.6}>
          <ArrowUpwardRoundedIcon color="success" fontSize="small" />
          <Typography color="success.main" fontWeight={850}>
            +18% em relação ao mês anterior
          </Typography>
        </Stack>

        <Typography fontSize={12} color="text.secondary" mt={1}>
          Receita consolidada da plataforma
        </Typography>
      </Box>

      {/* rodapé sutil p/ "encher" visual e dar cara premium */}
      <Box sx={{ mt: 2, pt: 1.5, borderTop: "1px solid rgba(11,18,32,0.06)" }}>
        <Typography fontSize={12} color="text.secondary">
          Atualizado há 2 min
        </Typography>
      </Box>
    </Paper>
  );
}
